import { useMemo, useState } from "react";

export function normalizeLogoDomain(domain?: string) {
  if (!domain?.trim()) return null;

  const trimmedDomain = domain.trim();

  try {
    const parsed = new URL(
      trimmedDomain.startsWith("http")
        ? trimmedDomain
        : `https://${trimmedDomain}`,
    );
    const hostname = parsed.hostname.replace(/^www\./, "");

    return hostname.includes(".") ? hostname : null;
  } catch {
    return null;
  }
}

export function buildLogoUrl(domain?: string) {
  const normalizedDomain = normalizeLogoDomain(domain);

  if (!normalizedDomain) return null;

  return `https://www.google.com/s2/favicons?domain=${normalizedDomain}&sz=256`;
}

const OnBoardingCompanyLogo = ({ domain }): any => {
  const [hasError, setHasError] = useState(false);
  const normalizedDomain = useMemo(() => normalizeLogoDomain(domain), [domain]);
  const logoUrl = useMemo(() => buildLogoUrl(domain), [domain]);

  if (!normalizedDomain || !logoUrl || hasError) return null;

  return (
    <img
      src={logoUrl}
      alt={`${normalizedDomain} logo`}
      className="inline-block h-[18px] w-[18px] object-contain object-center"
      onError={() => setHasError(true)}
    />
  );
};

export default OnBoardingCompanyLogo;
